import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useProductPackagingInsert = () => {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const insertRequest = ({
    branchGuid,
    packageName,
    description,
    packageLenght,
    identityType,
    identityCodeGuid,
    parentPackGuid,
    splittable,
    requiredScanning,
    handleRefetch,
  }) =>
    // eslint-disable-next-line max-params
    {
      setLoading(true);
      axiosClient
        .post(`Product/Branch/Packaging/Insert`, {
          branchGuid,
          display: packageName,
          description,
          count: packageLenght,
          identityType,
          identityCodeGuid,
          parentPackGuid,
          splittable,
          requiredScanning,
        })
        .then(res => {
          if (res.status === 200) {
            enqueueSnackbar(res.data?.message, { variant: 'success' });
            handleRefetch();
          } else {
            enqueueSnackbar(res?.message, { variant: 'error' });
          }
        })
        .catch(err => {
          enqueueSnackbar(err?.message, { variant: 'error' });
        })
        .finally(() => setLoading(false));
    };
  return [insertRequest, loading];
};

export default useProductPackagingInsert;
